module.exports = __webpack_public_path__ + "components/rewards/vista-tours/static/logo-03cf84c8fa97c87cc21ebd8b1a60d3a6.jpg";